<template>
  <v-card>
    <v-btn
      icon
      absolute
      top
      style="top: 10px"
      :to="
        '/weserve_admin_login/control/' +
        $route.params.province +
        '/rider/wallet'
      "
    >
      <v-icon>arrow_back</v-icon>
    </v-btn>

    <h1 class="text-pagename text-xs-center">Wallet transaction</h1>
    <v-layout>
      <v-spacer></v-spacer
      ><v-flex xs12 sm3>
        <v-select
          v-model="filterProvince"
          prepend-icon="mdi-filter-outline"
          label="Select Province"
          :items="provinceList"
          item-text="province_name_th"
          item-value="province_name_en"
          @change="getWalletTransactionList(filterProvince)"
        ></v-select></v-flex
    ></v-layout>

    <walletTransaction :loading_message="loading_message" />
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import walletTransaction from "../../../components/back-office/Rider/Wallet/Transaction";
export default {
  data() {
    return { loading_message: false, filterProvince: "", provinceList: [] };
  },
  components: {
    walletTransaction,
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  methods: {
    async getWalletTransactionList(province) {
      this.loading_message = true;
      await this.$store.dispatch("fetchCashRider/getRiderTransaction", {
        rider_id: this.$route.params.rider_id,
        province: province,
      });
      this.loading_message = false;
    },
    initProvince() {
      this.filterProvince = this.$route.params.province;
      this.provinceList = this.provinceData.map((val) => {
        val.province_name_en = val.province_name_en
          .replace(/ /g, "")
          .toLowerCase();
        return val;
      });
    },
  },
  created() {
    this.getWalletTransactionList(this.$route.params.province);
    this.initProvince();
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Rider",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse",
        // href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderdashboard'
      },
      {
        text: "Wallet",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/wallet",
      },
      {
        text: "Wallet transaction",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: transparent;
}
</style>
